import React, { useState } from 'react';

import CPageModuleTableBase, { type IPageModuleTableBaseProps } from '../CPageModuleTableBase';
import { updateStateAttribute } from '../helpers/helper';
import { type IBrowsableTableInternalState } from '../models/IBrowsableTableInternalState';
import CMutableTable, { type IMutableTableProps } from '../pages/playground/CMutableTable';

type Props = IMutableTableProps & Pick<IPageModuleTableBaseProps, 'style'>;

interface State {
  internalState?: IBrowsableTableInternalState;
}

export default function CPageModuleMutableTable(props: Props) {
  const [state, setState] = useState<State>({});

  return (
    <CPageModuleTableBase
      state={props.state}
      data={props.data}
      table={
        <CMutableTable
          {...props}
          onUpdateInternalState={(internalState) => {
            updateStateAttribute<State>({ internalState }, setState);
            props.onUpdateInternalState(internalState);
          }}
        />
      }
      pagination={state.internalState?.paginator}
      timestamp={state.internalState?.timestamp()}
      searchBar={props.searchBar !== false ? state.internalState?.searchBar : undefined}
      style={props.style}
    />
  );
}
